import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeHighlight from 'rehype-highlight';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import 'highlight.js/styles/github.css';
import { MarkdownContainer } from './MarkdownRenderV2.style';

interface MarkdownRenderProps {
  content: string;
}

export const MarkdownRenderV2: React.FC<MarkdownRenderProps> = ({content}) => {
  if (!content) return null;

  return (
    <MarkdownContainer>
      <ReactMarkdown
        rehypePlugins={[rehypeRaw, rehypeHighlight]}
        remarkPlugins={[remarkGfm]}
      >
        {content}
      </ReactMarkdown>
    </MarkdownContainer>
  );
};
